import { useParameterStore } from "@/frontend/store/ParameterStore";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { I18n } from "@/i18n/I18n";
import { ParameterSubjectType } from "@/types/parameterTypes";
import { useShallow } from "zustand/react/shallow";
import { ParameterLink } from "../parameters/ParameterLink";
import { Select } from "../Select";
import { Operation } from "@/backend/models/operation";
import { TextInput } from "./TextInput";


const fileTypes: { [key: string]: string } = {
  '*': I18n.get('any'),
  'video/*': I18n.get('video'),
  'image/*': I18n.get('image'),
  'audio/*': I18n.get('audio'),
  '.json': 'JSON',
  '.csv': 'CSV',
  '.pdf': 'PDF'
};

export function FileInputItem(props: { operation: Operation }) {
  const { operation } = props;
  const updateOperation = useTreeStore((state) => state.updateOperation);
  const [parameter] = useParameterStore(useShallow((state) => state.parametersForSubject(operation.id, ParameterSubjectType.OPERATION)));

  const onSelect = async (value: string) => {
    void updateOperation({ operation: { ...operation, inputConstraint: value } });
  };

  return (
    <div className="d-flex flex-column align-items-center">
      <div className="w-100">
        <TextInput operation={ operation } />
        <div className="pt-2">
          <div className='pb-2'>{I18n.get('displayedOnRun')}</div>
          <table>
            <tbody>
              <tr>
                <td>{I18n.get('fileType')}:</td>
                <td>
                  <Select label={I18n.get('specifyFileType')} value={operation.inputConstraint ? fileTypes[operation.inputConstraint] : I18n.get('any')}>
                    {Object.keys(fileTypes).map(fileType => (
                      <button key={fileType} type='button' className='w-100 dropdown-item' onClick={() => void onSelect(fileType)}>{fileTypes[fileType]}</button>
                    ))}
                  </Select>
                </td>
              </tr>
              <ParameterLink parameter={parameter} operation={operation} />
            </tbody>
          </table>
        </div>
      </div>
  </div>
  );
}
